// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2y-rO","buttons":"RemoveExpirationActionButtons_buttons__2wzKf"};